<template>
	
	<div class="full-width">

		<popoto :filters="between_filter" v-if="builder_show"></popoto>

		<span v-if="!builder_show">

			<div  class="va-layout gutter--md">
				
				<div class="va-row row wrap">
					<div id="from-wrapper" class="flex offset--lg4 xs12 lg4 md12 bg-light">
						<div id="prefilter-form" class="form-wrapper">
							
							<h1 class="title-form">Query builder prefilters</h1>

							<p class="intro-form">
								The below filters will be applied to ay queries run from this point after.
							</p><br>

							<va-input-wrapper  :messages="messages">
								<va-radio-button
								v-model="form_attribute"
								:error="hasError('form_attribute')"
								@focus="clearError('form_attribute')"
								option="created_at"
								label="Created at ( when the entity was created on twitter )"
								/>
								<va-radio-button
								v-model="form_attribute"
								:error="hasError('form_attribute')"
								@focus="clearError('form_attribute')"
								option="scraped_at"
								label="Indexed at ( when the entity was found by smart )"
								/>

								<small v-if="hasError('form_attribute')" class="invalid-input"> please select a attribute to apply range to. </small>

							</va-input-wrapper>

							<va-input-wrapper>


								<va-date-picker 
								:config="date.config"
								:error="hasError('form_date')"
								v-model="form_date" 
								@focus="clearError('form_date')"
								:label="date.label"></va-date-picker>

								<small v-if="hasError('form_date')" class="invalid-input up"> please select a date range. </small>

							</va-input-wrapper>

							<va-button 
							style="width: 97%;"
							color="info"
							toggle-color="success"
							@click="initQueryBuilder()"
							>
							Start query builder.
						</va-button>

					</div>
				</div>
			</div>

		</div>

	</span>

</div>

</template>

</template>
<style type="text/css">
.flatpickr-calendar.rangeMode.animate.inline,
.flatpickr-calendar.rangeMode.animate.inline {
	width: 100%;
	max-width: -webkit-fill-available;
}
.flatpickr-calendar.open, .flatpickr-calendar.inline{
	max-width: -webkit-fill-available !important;
}
#from-wrapper{
	height: 100%;
	position: relative;
	top: 4rem;
}
small.invalid-input {
	font-size: 0.8rem;
	color: #ef6969;
}

small.up{
	position: relative;
	bottom: 1rem;
}
</style>
<script>

	import QueryBuilder from './Query.vue'; 
	import Loading from 'vue-loading-overlay';
	import Event from '@/app/events';

	export default {

		components: { "popoto": QueryBuilder },

        /**
         * Data:
         * accesable object to Vue’s base reactivity system
         * @var <Observable>
         */
         data () {
         	return {

         		form_errors: [],
         		form_date:null,
         		form_attribute:null,
         		builder_show: false,
         		messages:[],
         		attributes:[
         		{id:'created_at',text:"TEST"},
         		{id:'scraped_at',text:"TEST2"}
         		],
         		date:{
         			label:"Find entites Between Time frame",
         			config: {mode: 'range', inline: true},
         		},
         	}
         },

         computed:{
         	between_filter:{
         		get(){

         			return this.form_date.split('to').map( (item,index) => {
         				return {
         					index: index,
         					attribute: this.form_attribute,
         					value: item,
         					operator: ( index < 1 ) ? ">" : "<"
         				}
         			});

         		}
         	}
         },

         created(){
         	this.builder_show = false;
         	this.$nextTick(() => {
         		this.$validator.validateAll()
         	})

         	Event.$on('kill_the_popoto', (popoto)=>{
         		this.builder_show = false;
               popoto = {};
         	});
         	
         },

         methods: {

         	hasError(name){

         		return this.form_errors.includes(name) ;

         	},

         	clearError(name){
         		this.form_errors.splice(0, this.form_errors.indexOf( item => item == name ));

         		

         	},

         	initQueryBuilder(){
         		
         		this.form_errors = [];

         		if(!this.form_date){
         			this.form_errors.push('form_date');
         		}

         		if(!this.form_attribute){
         			this.form_errors.push('form_attribute');
         		}

         		console.log(this.form_errors);

         		if( this.form_errors.length == 0){
         			this.builder_show = true;
         		}


         	}
         },


     }
 </script>

